module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-2-fd0100212ede3d7167b30135738eb416.jpg";